var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.28571 1.14453C1.025 1.14453 0 2.16953 0 3.43025V14.8588C0 16.1195 1.025 17.1445 2.28571 17.1445H13.7143C14.975 17.1445 16 16.1195 16 14.8588V3.43025C16 2.16953 14.975 1.14453 13.7143 1.14453H2.28571ZM5.10714 6.25167C5.44286 5.91596 5.98571 5.91596 6.31786 6.25167L7.99643 7.93025L9.675 6.25167C10.0107 5.91596 10.5536 5.91596 10.8857 6.25167C11.2179 6.58739 11.2214 7.13025 10.8857 7.46239L9.20714 9.14096L10.8857 10.8195C11.2214 11.1552 11.2214 11.6981 10.8857 12.0302C10.55 12.3624 10.0071 12.366 9.675 12.0302L7.99643 10.3517L6.31786 12.0302C5.98214 12.366 5.43929 12.366 5.10714 12.0302C4.775 11.6945 4.77143 11.1517 5.10714 10.8195L6.78571 9.14096L5.10714 7.46239C4.77143 7.12667 4.77143 6.58382 5.10714 6.25167Z",
    fill: "#FF004F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareX);
export default __webpack_public_path__ + "static/media/square-x.bdb81da61c54fd2cc1a386a65475fa0e.svg";
export { ForwardRef as ReactComponent };